import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Request} from '../../../classes/request';

@Component({
    selector: 'app-request-notes-modal',
    templateUrl: './request-notes-modal.component.html',
    styleUrls: ['./request-notes-modal.component.css']
})
export class RequestNotesModalComponent implements OnInit {
    @Input() public request: Request = new Request();

    constructor(public activeModal: NgbActiveModal) { }

    ngOnInit(): void {
    }

    onNotesCountChange(count: number): void {
        this.request.NotesCount = count;
    }
}
